import styled from "styled-components";
import {
	Avatar as AntAvatar,
	Input as AntInput,
	Button as AntButton,
	Form as AntForm,
} from "antd";
import { NoImageUser, CameraFill } from "@assets";

export const RootContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	position: relative;
	margin: 0 16px;
	min-height: calc(100vh - 70px);
	gap: 16px;
	overflow: hidden;
`;

export const AvatarWrapper = styled.div`
	margin: 16px 0 0;
`;

export const Avatar = styled(AntAvatar)`
	border-radius: 50% !important;
`;

export const ProfileInputContainer = styled.div`
	position: absolute;
	bottom: 0px;
	right: 0px;
	border-radius: 0px 0px 12px 12px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const InputLabel = styled.p`
	position: absolute;
	left: 24px;
	top: -8px;
	z-index: 30;
	margin: 0px;
	padding: 0px 4px;
	color: #535b5d;
	background-color: white;
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
`;

export const Input = styled(AntInput)`
  padding-left: 13px;
  height: 55px;
  border-radius: 12px;
  background: #FFF !important;
  border: 1px solid #5C5C5C !important;

  color: #000 !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

	.ant-input {
		font-size: 17px !important;
	}

	input:hover{
		border: none !important;
	}

	.ant-input::placeholder {
    color: #9F9F9F !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
	}

	&&& {
		padding-left: 24px;
	}

`;

export const FileInput = styled.input`
	display: none;
`;

export const SaveButton = styled(AntButton)`
	box-sizing: border-box !important ;
	width: calc(100%) !important;
	height: 52px;
	margin: 0px 0 20px;
`;

export const NoImageIcon = styled.img.attrs({
	src: `${NoImageUser}`,
	alt: "no_img",
})`
	margin-top: 4px;
	width: 73px;
	height: 73px;
`;

export const Form = styled(AntForm)`
	width: 100%;
	height: 100%;
	position: relative !important;

	.ant-form-item {
		margin: 0 0 24px 0px;
	}

	.ant-form-item-label > label.ant-form-item-required::before {
		content: none;
	}

	.ant-form-item-label label {    
		color: #2A2A2A !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */
	}

	.ant-form-item-explain {
		text-align: left; /* align warning text to the left */
		margin-left: 24px;
	}

	.ant-input-affix-wrapper-readonly{
		background-color: #DBDBDB !important;
	}

	.ant-input-affix-wrapper-readonly > input{
		cursor: not-allowed;
	}
`;

// export const Phone = styled.span`
// 	color: ${(props) => (props.text ? "#5d5189" : "#9B92BB")};
// 	font-size: 14px;
// 	font-weight: 400;
// 	line-height: 21.17px;
// `;

// export const PhoneWrapper = styled.div`
// 	margin-top: 8px;
// `;


export const CameraIcon = styled(CameraFill)`

`

export const LevelBadge = styled.div`
	padding: 2px 12px;
	border-radius: 100px;
	background: rgba(0, 0, 0, 0.50);

	color: #FFF;
	font-size: 10px;
	font-style: normal;
	font-weight: 700;
	line-height: 20px; /* 200% */

	height: 24px;
	width: 78px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
`;